module.exports = __webpack_public_path__ + "img/home-bottom@2x.6de42614.png";